var $8751d9847e270a98$exports = {};
$8751d9847e270a98$exports = {
    "loading": `\u{8F09}\u{5165}\u{4E2D}\u{2026}`,
    "loadingMore": `\u{6B63}\u{5728}\u{8F09}\u{5165}\u{66F4}\u{591A}\u{2026}`
};


export {$8751d9847e270a98$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
